import Config from "../config/apiUrl";
import { Request } from "../config/request";
import { storage } from "src/services/config/storage";

/*
 * The proctoring review room's reads (assess-be, src/routes/reportingRoutes.js).
 * They are open at report-data's level (the linkId + userId pair).
 *
 * The room talks to REACT_APP_PROCTORING_REVIEW_API_ENDPOINT when an environment serves the
 * review elsewhere (the main API otherwise). Reads go through the usual Request.safeCall,
 * which resolves with the error body on an HTTP error.
 */
const BASE = "/api/reporting/v1/proctoring-review";
const q = (params) => new URLSearchParams(params).toString();
const ReviewApi = new Request(Config.PROCTORING_REVIEW_API_URL, storage.get.authToken);

const ProctoringReviewApi = {
  /** The normalised timeline: clock, presence, parts, questions, captures, audio, integrity, recordings. */
  getTimeline(linkId, userId) {
    return ReviewApi.safeCall(`${BASE}?${q({ linkId, userId })}`, "GET");
  },

  /**
   * Freshly presigned media: `{kind, expiresAt, clips[{id, sessionId, from, to, link}]}` for
   * user | screen | audio, or `{kind, expiresAt, urls{key: url}}` for images.
   */
  getMedia(linkId, userId, kind) {
    return ReviewApi.safeCall(`${BASE}/media?${q({ linkId, userId, kind })}`, "GET");
  },
};

export default ProctoringReviewApi;
